import { AuditResult, Rating } from '@blisspointmedia/bpm-types/dist/GoogleAdsAudit';

export interface RatingCounts {
  large: number;
  medium: number;
  small: number;
  ok: number;
  na: number;
}

const countByRating = (results: AuditResult[]): RatingCounts => ({
  large: results.filter(r => r.rating === 'large').length,
  medium: results.filter(r => r.rating === 'medium').length,
  small: results.filter(r => r.rating === 'small').length,
  ok: results.filter(r => r.rating === 'ok').length,
  na: results.filter(r => r.rating === 'na').length
});

export const hasCriticalFinding = (results: AuditResult[]): boolean =>
  results.some(r => r.rating === 'large');

export interface AuditSummary {
  counts: RatingCounts;
  hasCritical: boolean;
}

// Deliberately no single composite "health score": an unweighted OK/scoreable pass rate
// treats a cosmetic Small finding the same as a critical Large one, so the resulting
// percentage reads as more rigorous than the math behind it actually is. The rating
// counts below are the real signal — surface those, not a manufactured number.
export const summarizeAudit = (results: AuditResult[]): AuditSummary => ({
  counts: countByRating(results),
  hasCritical: hasCriticalFinding(results)
});

export const groupBySection = (results: AuditResult[]): Record<string, AuditResult[]> =>
  results.reduce<Record<string, AuditResult[]>>((acc, result) => {
    (acc[result.sectionId] ??= []).push(result);
    return acc;
  }, {});

export const RATING_ORDER: Rating[] = ['large', 'medium', 'small', 'ok', 'na'];
